import { ITransportCapacityRepository } from '../domain/ITransportCapacityRepository';
import { transportCapacityRepository } from '../infrastructure/repositories/TransportCapacityRepository';

class GetLongTermCapacitiesDashboardUseCase {
  private readonly _repository: ITransportCapacityRepository;

  constructor({ repository }) {
    this._repository = repository;
  }

  execute(): Promise<string> {
    return this._repository.getLongTermCapacitiesDashboardUrl();
  }
}

export const getLongTermCapacitiesDashboardUseCase =
  new GetLongTermCapacitiesDashboardUseCase({
    repository: transportCapacityRepository
  });

export { GetLongTermCapacitiesDashboardUseCase };
